import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import { isDesktop, isMobile } from 'react-device-detect';
import useStatementBalance, { StatementBalanceAction } from './StatementBalance.Hooks';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import StatementUploadDocuments from './sections/StatementBalance.UploadDocuments';
import { isEmpty } from 'lodash';
import StatementBalanceCreate from './sections/StatementBalance.Create';
import StatementBalancePrint from './sections/StatementBalance.Print';
import StatementBalanceDelete from './sections/StatementBalance.Delete';
import StatementBalanceList from './sections/StatementBalance.List';
import StatementBalanceFilters from './sections/StatementBalance.Filters';
import StatementBalanceSendEmail from './sections/StatementBalance.SendEmail';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const statementBalanceIndexRoute = salesHomeRoute + '/statementBalance/:action?/:id?';
export default function StatementBalanceIndex() {
  const { lang } = getLocales();
  const statementBalanceHook = useStatementBalance();
  const { permissions } = useAuthStore();

  if (!statementBalanceHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={statementBalanceHook}
        render={({
          listApi,
          views,
          pageRouter,
          selectedBalanceStatements,
          isSendingEmails,
          sendEmailsForSelectedBalanceStatements,
        }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.statementBalances} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <StatementBalanceFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-envelope" />}
                    render={!isMobile && lang.sendEmails}
                    onClick={sendEmailsForSelectedBalanceStatements}
                    isLoading={isSendingEmails}
                    disabled={
                      !(
                        permissions?.CREATE_STATEMENTBALANCE ||
                        permissions.EDIT_STATEMENTBALANCE ||
                        permissions.MODIFY_STATEMENTBALANCE_EMAIL
                      ) || isEmpty(selectedBalanceStatements)
                    }
                  />
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions?.CREATE_STATEMENTBALANCE}
                    data={{ action: StatementBalanceAction.CREATE }}
                  />
                </Box>
              </>
            }
            subHeader={isDesktop && <StatementBalanceFilters />}
            render={
              <>
                {views.create && <StatementBalanceCreate />}
                {views.uploadDocument && <StatementUploadDocuments />}
                {views.print && <StatementBalancePrint />}
                {views.delete && <StatementBalanceDelete />}
                {views.sendEmail && <StatementBalanceSendEmail />}
                <StatementBalanceList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
